import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {TaskCalendarHeaderComponent} from './header/task-calendar-header.component';

@Component({
  selector: 'task-calendar',
  standalone: true,
  imports: [MatDatepickerModule],
  templateUrl: './task-calendar.component.html',
  styleUrls: ['./task-calendar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskCalendarComponent {
  // Input signals
  control = input.required<FormControl>();
  disabled = input<boolean>(false);
  focused = input<boolean>(false);
  hideBorder = input<boolean>(false);
  form = input.required<FormGroup>();
  minDate = input<moment.Moment>();

  // Output signal
  dateChange = output<Date>();

  today = new Date();
  headerComponent = TaskCalendarHeaderComponent;

  onDateChange(date: Date) {
    this.dateChange.emit(date);
    this.control().setValue(date);
  }
}
